const isSameMove = (move1, move2) => move1.id === move2.id;

export const isSignedOut = mover => !mover.isSignedIn;
export const isSignedIn = mover => !!mover.isSignedIn;

export const menuItems = mover => {
  const moveId = mover?.currentMoveId;
  return (
    [
      {
        name: `I'm Moving`,
        href: '/sign-in',
        useCtrl: true,
        show: isSignedOut(mover),
        method: 'goToSignIn',
      },
      {
        name: `Real Estate Pros`,
        href: '/professionals/sign-in',
        show: isSignedOut(mover),
      },
      {
        name: mover.firstName,
        classes: ['headerItem moverName hiddenSm hiddenMd hiddenLg'],
        show: isSignedIn(mover),
      },
      {
        name: 'My Dashboard',
        href: '/dashboard',
        classes: ['chevron right'],
        show: isSignedIn(mover),
      },
      {
        name: 'My Account',
        href: '/account/profile',
        classes: ['chevron right'],
        show: isSignedIn(mover),
      },
      {
        name: 'Move Summary',
        href: `/account/moves/${moveId}/summary`,
        params: { moveId },
        classes: ['chevron right'],
        show: isSignedIn(mover),
      },
      {
        name: 'Switch to Another Move',
        classes: ['submenu'],
        options: mover.moves.map(move => {
          const isCurrentMove =
            mover.currentMove && isSameMove(move, mover.currentMove);
          return {
            id: `moveId${move.id}`, // Unique id for preact Key`.
            name: `${move.from_address?.zip} → ${move.to_address.zip}`,
            href: `/dashboard?moveId=${move.id}`,
            params: { moveId: move.id },
            isCurrentMove,
            classes: isCurrentMove ? ['currentMove'] : [],
          };
        }),
        show: mover.moves.length > 1,
      },
      {
        name: 'My Deals',
        href: '/move-in-promotions/',
        classes: ['chevron right'],
        show: isSignedIn(mover),
      },
      {
        name: `I'm Moving Again`,
        href: '/account/moves/new',
        classes: ['chevron right'],
        show: isSignedIn(mover),
      },
      {
        name: 'Sign Out',
        href: '/sign-out',
        show: isSignedIn(mover),
      },
    ]
      // Unique id for preact's Key
      .map((item, index) => ({ ...item, id: index }))
      .filter(item => item.show)
  );
};
